import { Alert, FlashbarProps, SpaceBetween, Spinner, Tabs } from '@amzn/awsui-components-react-v3';
import { SchemaTab } from './tabs/schema';
import { ContractTab } from './tabs/contract';
import { getDataSetId } from '../common/utils';
import { ContractHeader } from './ContractHeader';

import React, { useEffect, useState } from 'react';
import { getDataset } from '../../../api/ingestion';
import { iTethysRouteProps } from '../common/types';
import { TABLE_CONTENT_TYPE } from 'src/commons/constants';
import { iIngestionComponentProps } from '../registerContract';
import { GetDataSetResponse } from 'aws-sdk/clients/tethyscontractservicelambda';

interface iDatasetDetail extends iIngestionComponentProps {
  params: iTethysRouteProps;
  setNotifications(notifications: FlashbarProps.MessageDefinition[]): void;
}

export const DatasetDetail = (props: iDatasetDetail) => {
  const { params, setContentType, setNotifications } = props;
  const [errorMsg, setErrorMsg] = useState(false);
  const [DataSetId, setDatasetId] = useState<string>();
  const [loading, setLoading] = useState<boolean>(true);
  const [dataset, setDataset] = useState<GetDataSetResponse>();

  useEffect(() => {
    setContentType(TABLE_CONTENT_TYPE);
    const id = getDataSetId(params);

    fetchDataset(id);
    setDatasetId(id);
  }, []);

  const fetchDataset = async (id: string) => {
    setLoading(true);
    try {
      const dataset = await getDataset({ DataSetId: id });
      setDataset(dataset);
    } catch (e) {
      setErrorMsg(true);
    }
    setLoading(false);
  };

  const tabs = [
    {
      label: 'Data contract',
      id: 'contract',
      content: <ContractTab dataset={dataset} arn={params.arn} {...props} />,
    },
    {
      label: 'Schema definition',
      id: 'schema',
      content: <SchemaTab dataset={dataset} />,
    },
  ];

  if (loading) return <Spinner />;
  if (errorMsg || !dataset.DataContract)
    return <Alert type='warning'>Error loading dataset. Contact Tethys Support (AWS-DI).</Alert>;

  return (
    <>
      <SpaceBetween size='l'>
        <ContractHeader dataset={dataset} {...props} />
        <Tabs tabs={tabs} ariaLabel='Resource details' />
      </SpaceBetween>
    </>
  );
};
